module.exports = __webpack_public_path__ + "media/images/mailer/program-5c265e759652b371e54a254c5ae52f2c.jpg";